import { Point } from '../../../shared/types/mathTypes.ts';
import { ContextMenu, MenuItem } from '../../components/contextMenu.tsx';
import { Protocol } from '../../types/sharedTypeImpl.ts';


export interface ProtocolContextMenuState {
    protocol: Protocol;
    screenCoords: Point;
}


interface Props {
    protocol: Protocol;
    screenCoords: Point;
    onEnableSelected: (protocol: Protocol) => void;
    onDisableSelected: (protocol: Protocol) => void;
    onProtocolDraftDelete: (protocol: Protocol) => void;
    onCopySelected: (protocol: Protocol) => void;
    onClose: () => void;
}

export function ProtocolContextMenu({
    protocol,
    screenCoords,
    onEnableSelected,
    onDisableSelected,
    onProtocolDraftDelete,
    onCopySelected,
    onClose,
}: Props) {

    const menuItems: MenuItem[] = [
        {
            text: 'Enable',
            isEnabled: !!protocol.isDisabled,
            callback: () => onEnableSelected(protocol),
        },
        {
            text: 'Disable',
            isEnabled: !protocol.isDisabled,
            callback: () => onDisableSelected(protocol),
        },
        {
            text: 'Copy',
            callback: () => onCopySelected(protocol),
        },
        {
            text: 'Delete',
            isEnabled: protocol.status === 'draft' || protocol.status === 'rejected',
            callback: () => onProtocolDraftDelete(protocol),
        }
    ];

    return (
        <ContextMenu
            isOpen={true}
            position={screenCoords}
            items={menuItems}
            close={onClose}
        />
    );
}
